"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HANDSHAKE_DEFAULT_SERVICE_FEE_PERCENT = exports.CASE_DEFAULT_SERVICE_FEE_PERCENT = exports.PROJECT_INVITE_SIGNUP_QUERY_PARAM = exports.CASE_CLIENT_SIGNUP_QUERY_PARAM = exports.CASE_SIGNUP_SOURCE = exports.ID_STRUCTURE_METADATA_KEY = exports.CASE_WORKFLOW_METADATA_KEY = exports.CASE_INSTANT_RELEASE_PERCENT_SUBSEQUENT = exports.CASE_DEPOSIT_MIN_PERCENT = exports.CASE_DEPOSIT_MAX_PERCENT = exports.CASE_DEPOSIT_DEFAULT_PERCENT = exports.CASE_DEPOSIT_MILESTONE_NAME = void 0;
exports.CASE_DEPOSIT_MILESTONE_NAME = "Deposit";
exports.CASE_DEPOSIT_DEFAULT_PERCENT = 10;
exports.CASE_DEPOSIT_MAX_PERCENT = 20;
exports.CASE_DEPOSIT_MIN_PERCENT = 0.01;
exports.CASE_INSTANT_RELEASE_PERCENT_SUBSEQUENT = 50;
exports.CASE_WORKFLOW_METADATA_KEY = "case";
/** Interior Design (ID) project structure — same payment rules as CaseTrust, no CaseTrust brand. */
exports.ID_STRUCTURE_METADATA_KEY = "id";
exports.CASE_SIGNUP_SOURCE = "case-flow";
/** Query param on client signup links from CaseTrust project invitations. */
exports.CASE_CLIENT_SIGNUP_QUERY_PARAM = "case-flow";
/** Query param on client signup links from any project invitation email. */
exports.PROJECT_INVITE_SIGNUP_QUERY_PARAM = "invite";
/** Handshake service fee for CASE Trust businesses (business pays 100%). */
exports.CASE_DEFAULT_SERVICE_FEE_PERCENT = 0.9;
exports.HANDSHAKE_DEFAULT_SERVICE_FEE_PERCENT = 1.2;
